import * as slider from './slider.js';
import * as comicSlider from './comicSlider.js';
import * as ad from './ad.js';
import * as virtualPv from './virtualPv.js';
import * as inArticle from './inArticle.js';

window.addEventListener('DOMContentLoaded', function() {
  slider.infinitiSlideInit();
  comicSlider.initialize();
  virtualPv.initialize();
  ad.initialize();
  inArticle.initialize();
});
